import { render, staticRenderFns } from "./GenericFormModal.vue?vue&type=template&id=533a5317&"
import script from "./GenericFormModal.vue?vue&type=script&lang=js&"
export * from "./GenericFormModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports